export const getActiveCategories = (categories = []) =>
  (Array.isArray(categories) ? categories : []).filter((cat) => cat && cat.active !== false);

export const getMainCategorySlug = (product = {}, categories = []) => {
  if (product.mainCategory) return String(product.mainCategory).toLowerCase();
  const direct = getActiveCategories(categories).find(
    (cat) => String(cat.slug).toLowerCase() === String(product.category || "").toLowerCase()
  );
  if (direct) return String(direct.slug).toLowerCase();
  const parent = getActiveCategories(categories).find((cat) =>
    (cat.subcategories || []).some(
      (sub) => String(sub.slug).toLowerCase() === String(product.subCategory || product.category || "").toLowerCase()
    )
  );
  return parent ? String(parent.slug).toLowerCase() : "";
};

export const getSubCategorySlug = (product = {}, categories = []) => {
  if (product.subCategory) return String(product.subCategory).toLowerCase();
  const parent = getActiveCategories(categories).find((cat) =>
    (cat.subcategories || []).some(
      (sub) => String(sub.slug).toLowerCase() === String(product.category || "").toLowerCase()
    )
  );
  const sub = parent?.subcategories?.find(
    (item) => String(item.slug).toLowerCase() === String(product.category || "").toLowerCase()
  );
  return sub ? String(sub.slug).toLowerCase() : "";
};

export const getSubcategoriesForMain = (categories = [], mainSlug = "") => {
  const main = getActiveCategories(categories).find(
    (cat) => String(cat.slug).toLowerCase() === String(mainSlug).toLowerCase()
  );
  return (main?.subcategories || []).filter((sub) => sub.active !== false);
};

export const getCategoryDisplay = (product = {}, categories = []) => {
  const mainSlug = getMainCategorySlug(product, categories);
  const subSlug = getSubCategorySlug(product, categories);
  const main = getActiveCategories(categories).find(
    (cat) => String(cat.slug).toLowerCase() === String(mainSlug).toLowerCase()
  );
  const sub = (main?.subcategories || []).find(
    (item) => String(item.slug).toLowerCase() === String(subSlug).toLowerCase()
  );
  return {
    mainName: main?.name || mainSlug || product.mainCategory || product.category || "",
    subName: sub?.name || subSlug || product.subCategory || "",
    label: sub?.name ? `${main?.name || mainSlug} / ${sub.name}` : (main?.name || mainSlug || product.category || ""),
  };
};

export const getAllowedCategorySlugs = (categories = [], mainSlug = "") => {
  const main = getActiveCategories(categories).find(
    (cat) => String(cat.slug).toLowerCase() === String(mainSlug).toLowerCase()
  );
  if (!main) return [String(mainSlug).toLowerCase()].filter(Boolean);
  return [
    String(main.slug).toLowerCase(),
    ...(main.subcategories || []).filter((sub) => sub.active !== false).map((sub) => String(sub.slug).toLowerCase()),
  ];
};
